import { ICurriculumItemableSearchResult, ISearchModel } from 'holberton-school-intranet-api';
import * as React from 'react';
import { ReactElement, useEffect, useRef } from 'react';

import Icon from '../../../common/Icon';
import { BuilderSearchItemRenderer } from '../BuilderSearch';

interface IProps {
    hasMore: boolean;
    items: ICurriculumItemableSearchResult[];
    loadingMore: boolean;
    model: ISearchModel;
    onLoadMore: () => void;
    renderItem: BuilderSearchItemRenderer;
}

export default function BuilderSearchHits({
    hasMore,
    items,
    loadingMore,
    model,
    onLoadMore,
    renderItem,
}: IProps): ReactElement {
    const sentinelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!sentinelRef.current || !hasMore) {
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && hasMore && !loadingMore) {
                    onLoadMore();
                }
            });
        });
        observer.observe(sentinelRef.current);

        return (): void => observer.disconnect();
    }, [hasMore, loadingMore, onLoadMore]);

    return (
        <div
            className="list-group-item p-0"
            style={{
                maxHeight: '500px',
                overflowY: 'scroll',
            }}
        >
            <div className="list-group mb-0">
                {items.map((item) => renderItem(item, item.model ?? model))}

                {hasMore && (
                    <div
                        className="list-group-item text-center"
                        ref={sentinelRef}
                    >
                        <Icon name="spinner" spin />
                    </div>
                )}
            </div>
        </div>
    );
}
